import Joi from 'joi';

import { FuelConsumptionUnitEnum } from '../../../shared/enums/fuel-consumption-unit.enum';
import { FuelPolicyTypeEnum } from '../../enums/fuel-policy-type.enum';

/**
 * Schema for fuel policy config validation
 */
export const fuelConfigSchema = () =>
	Joi.object({
		type: Joi.string()
			.valid(...Object.values(FuelPolicyTypeEnum))
			.required(),

		refuelChargePerUnit: Joi.number().allow(null).optional(),
		refuelFlatCharge: Joi.number().allow(null).optional(),
		prepaidTankPrice: Joi.number().allow(null).optional(),
		fuelChargePerUnit: Joi.number().allow(null).optional(),
		chargeUnit: Joi.string()
			.valid(...Object.values(FuelConsumptionUnitEnum))
			.allow(null)
			.optional(),
	})
		.unknown(false)
		.custom((value, helpers) => {
			if (
				value.type === FuelPolicyTypeEnum.FULL_TO_EMPTY &&
				value.prepaidTankPrice == null
			) {
				return helpers.error('any.custom', {
					message: 'prepaidTankPrice is required for full_to_empty policy',
				});
			}

			if (
				value.type === FuelPolicyTypeEnum.PAY_AS_YOU_GO &&
				value.fuelChargePerUnit == null
			) {
				return helpers.error('any.custom', {
					message: 'fuelChargePerUnit is required for pay_as_you_go policy',
				});
			}

			if (
				(value.type === FuelPolicyTypeEnum.FULL_TO_FULL ||
					value.type === FuelPolicyTypeEnum.SAME_TO_SAME) &&
				value.refuelChargePerUnit == null &&
				value.refuelFlatCharge == null
			) {
				return helpers.error('any.custom', {
					message:
						'refuelChargePerUnit or refuelFlatCharge is required for ' +
						'full_to_full and same_to_same policies',
				});
			}

			return value;
		});
